// @ts-generator-hash: c853f8fcc46f2d8753d4c0f4f1c08d9834d72dcc96fd2a89181f02a39dac9f21
// Generation date: 10/13/2025 11:48:02 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.GrantStatus
export enum GrantStatus {
  AWARDED = 5,
  APPLICATION = 7,
  COUNCILREVIEW = 12,
  AWARDPREPARED = 19,
  TOBEPAID = 35,
}
